import { OtpEmailVerification } from '@/screens/profile-screen/OtpEmailVerification'

export default function () {
  return <OtpEmailVerification />
}
